import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import styles from './Countdown.module.css';

const targetDate = new Date('2026-08-01T00:00:00');

const Countdown: React.FC = () => {
   const { t } = useTranslation();
   const calculateTimeLeft = () => {
      const now = new Date();
      const difference = targetDate.getTime() - now.getTime();

      if (difference <= 0) return null;

      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((difference / 1000 / 60) % 60);
      const seconds = Math.floor((difference / 1000) % 60);

      return { days, hours, minutes, seconds };
   };

   const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

   useEffect(() => {
      const timer = setInterval(() => {
         setTimeLeft(calculateTimeLeft());
      }, 1000);

      return () => clearInterval(timer);
   }, []);

   if (!timeLeft) {
      return (
         <div className={styles.countdown}>
            <p className={styles.title}>{t('countdown.celebration')}</p>
         </div>
      );
   }

   return (
      <div className={styles.countdown}>
         <div className={styles.timeContainer}>
            <div className={styles.unit}>
               <span className={styles.value}>{timeLeft.days}</span>
               <span className={styles.label}>{t('countdown.days')}</span>
            </div>
            <div className={styles.unit}>
               <span className={styles.value}>{timeLeft.hours}</span>
               <span className={styles.label}>{t('countdown.hours')}</span>
            </div>
            <div className={styles.unit}>
               <span className={styles.value}>{timeLeft.minutes}</span>
               <span className={styles.label}>{t('countdown.minutes')}</span>
            </div>
            <div className={styles.unit}>
               <span className={styles.value}>{timeLeft.seconds}</span>
               <span className={styles.label}>{t('countdown.seconds')}</span>
            </div>
         </div>
      </div>
   );
};

export default Countdown;
